<div fxLayout="row" fxLayoutAlign="end end">
  <button class="dialog-close-button" mat-mini-fab color="warn" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
  </button>
</div>
<div fxLayout="column">
 <app-new-tpd-report (saveCompleted)="closeDialog($event)"></app-new-tpd-report>
</div>
